module.exports = __webpack_public_path__ + "static/media/kuu.2ee70eab.png";